import { useState } from "react";
import { X, Play, Music } from "lucide-react";

/**
 * ArtistChip - visual card for a selected artist with Spotify preview.
 * Props: artist (object), artistId (fallback), onRemove (null when locked),
 *        testId, removeTestId, subtitle (optional replacement for the "DK"/"INT" line).
 */
export default function ArtistChip({ artist, artistId, onRemove, testId, removeTestId, subtitle }) {
  const [showPreview, setShowPreview] = useState(false);
  const hasSpotify = !!artist?.spotify_id;
  const genres = (artist?.genres || []).slice(0, 2).join(" · ");

  return (
    <div className="card-flat overflow-hidden" data-testid={testId}>
      <div className="flex gap-3 p-3 items-center">
        {artist?.image_url ? (
          <img src={artist.image_url} alt="" className="w-14 h-14 rounded-md object-cover flex-shrink-0" />
        ) : (
          <div className="w-14 h-14 rounded-md bg-zinc-800 flex items-center justify-center flex-shrink-0">
            <Music size={16} className="text-zinc-600" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="font-medium truncate">{artist?.name || artistId}</div>
          <div className="text-xs text-zinc-500 mt-0.5 truncate">
            {subtitle || (artist?.is_danish ? "Dansk" : "International")}
            {genres && <span className="text-zinc-600"> · {genres}</span>}
          </div>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          {hasSpotify && (
            <button
              onClick={() => setShowPreview(s => !s)}
              className={`p-1.5 rounded hover:bg-white/5 ${showPreview ? "text-emerald-400" : "text-zinc-500"}`}
              data-testid={`${testId}-play`}
              aria-label="Afspil"
            >
              <Play size={14} />
            </button>
          )}
          {onRemove && (
            <button onClick={onRemove} className="p-1.5 rounded text-zinc-500 hover:text-red-400 hover:bg-red-500/5" data-testid={removeTestId} aria-label="Fjern">
              <X size={16} />
            </button>
          )}
        </div>
      </div>
      {showPreview && hasSpotify && (
        <div className="border-t border-white/5">
          <iframe
            src={`https://open.spotify.com/embed/artist/${artist.spotify_id}?utm_source=fm27&theme=0`}
            width="100%" height="152" frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title={`Spotify preview for ${artist.name}`}
            data-testid={`${testId}-iframe`}
          />
        </div>
      )}
    </div>
  );
}
